import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

export function lengthValidator(
  length: number,
  translate: TranslateService,
  errorTranslateKey?: string,
  orEmpty = false
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (orEmpty && (control.value === null || control.value === '' || control.value === undefined)) return null;
    if (
      control.value === null ||
      control.value === undefined ||
      control.value === '' ||
      control.value.length < length
    ) {
      let stringMsg = '';
      const keys = ['error.validation.length.part1', 'error.validation.length.part2'];
      if (errorTranslateKey) {
        keys.push(errorTranslateKey);
      }
      translate.get(keys).subscribe((translations) => {
        stringMsg = errorTranslateKey
          ? translations[errorTranslateKey]
          : translations['error.validation.length.part1'] +
            ' ' +
            length +
            ' ' +
            translations['error.validation.length.part2'];
      });
      return { invalidLength: { value: control.value, msg: stringMsg } };
    }
    return null;
  };
}
